import { Component, inject } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { IServicio } from 'modelos/src';
import { ButtonComponent } from '../../../../auxiliares/button/button.component';
import { CardHeaderComponent } from '../../../../componentes/card-header/card-header.component';
import { ContentCardComponent } from '../../../../componentes/content-card/content-card.component';
import { CarruselComponent } from '../../../../auxiliares/carrusel/carrusel.component';

@Component({
  selector: 'app-detalle-servicio',
  templateUrl: './detalle-servicio.component.html',
  styleUrl: './detalle-servicio.component.scss',
  standalone: true,
  imports: [
    MatDialogModule,
    DecimalPipe,
    MatCardModule,
    MatDividerModule,
    ButtonComponent,
    CardHeaderComponent,
    ContentCardComponent,
    CarruselComponent,
  ],
})
export class DetalleServicioComponent {
  private datePipe = new DatePipe('es-AR');
  public servicio = inject<IServicio>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<DetalleServicioComponent>>(MatDialogRef, {
    optional: true,
  });

  get esCombustible(): boolean {
    return this.servicio?.tipo === 'Combustible';
  }

  get vehiculoLabel(): string {
    return this.servicio?.categoria === 'Colectivo' ? 'Colectivo' : 'Vehículo';
  }

  get conductorLabel(): string {
    return this.servicio?.categoria === 'Colectivo' ? 'Chofer' : 'Conductor';
  }

  /** Nombre del usuario poblado del permiso, con fallback al texto libre. */
  get nombreUsuario(): string {
    const u = this.servicio?.usuario;
    return (
      u?.datosPersonales?.nombre ??
      u?.usuario ??
      this.servicio?.nombreChofer ??
      'Sin asignar'
    );
  }

  get fechaTexto(): string {
    return this.servicio?.fechaRealizacion
      ? (this.datePipe.transform(
          this.servicio.fechaRealizacion,
          'dd/MM/yyyy',
        ) ?? 'Sin reportar')
      : 'Sin reportar';
  }

  get costoTexto(): string {
    return this.servicio?.costo != null
      ? `$${this.servicio.costo.toLocaleString('es-AR', {
          minimumFractionDigits: Number.isInteger(this.servicio.costo) ? 0 : 2,
          maximumFractionDigits: 2,
        })}`
      : '';
  }
}
